<template>
    <div class="col-lg-9">
        <div class="bg-white rounded shadow-sm">
            <div class="card-content px-0">
                <div class="modal-header d-flex align-items-center">
                    <h5 class="modal-title font-weight-400">Create User</h5>
                    <router-link class="btn btn-link ml-auto btn-sm" to="/business/users">Back to list</router-link>
                </div>
                <div class="p-4">
                    <form @submit.prevent="create" method="post">
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <label>First Name</label>
                                    <input type="text" v-model="form.first_name"
                                           :class="[ 'form-control' , form.errors.get('first_name') ? 'is-invalid' : '' ]"
                                           placeholder="Enter first name">
                                    <div v-text="form.errors.get('first_name')" class="invalid-feedback"/>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <label>Last Name</label>
                                    <input type="text" v-model="form.last_name"
                                           :class="[ 'form-control' , form.errors.get('last_name') ? 'is-invalid' : '' ]"
                                           placeholder="Enter last name">
                                    <div v-text="form.errors.get('last_name')" class="invalid-feedback"/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <label>Email</label>
                                    <input type="email" v-model="form.email"
                                           autocomplete="username"
                                           :class="[ 'form-control' , form.errors.get('email') ? 'is-invalid' : '' ]"
                                           placeholder="Enter email">
                                    <div v-text="form.errors.get('email')" class="invalid-feedback"/>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <label>Phone</label>
                                    <input type="tel" v-model="form.phone"
                                           autocomplete="phone"
                                           :class="[ 'form-control' , form.errors.get('phone') ? 'is-invalid' : '' ]"
                                           placeholder="Enter phone">
                                    <div v-text="form.errors.get('phone')" class="invalid-feedback"/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <label>Password</label>
                                    <input type="password" v-model="form.password"
                                           :class="[ 'form-control' , form.errors.get('password') ? 'is-invalid' : '' ]"
                                           placeholder="Enter password">
                                    <div v-text="form.errors.get('password')" class="invalid-feedback"/>
                                </div>
                            </div>
                            <div class="col-12 col-sm-6">
                                <div class="form-group">
                                    <label>Password Repeat</label>
                                    <input type="password" v-model="form.password_confirmation"
                                           :class="[ 'form-control' , form.errors.get('password_confirmation') ? 'is-invalid' : '' ]"
                                           placeholder="Repeat password">
                                    <div v-text="form.errors.get('password_confirmation')" class="invalid-feedback"/>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-12">
                                <h3 class="text-5 font-weight-400 mt-3">Permissions</h3>
                                <div v-text="form.errors.get('permissions')" class="text-danger"/>
                                <hr>
                            </div>

                            <div class="col-12 pb-4">
                                <div class="row">
                                    <div class="col-6 pb-4">
                                        <div v-for="(category, key) in permissionCategories" :key="key" class="mb-2">
                                            <h5 @click="toggleCategory(key)" class="role-category d-flex justify-content-between align-items-center">
                                                <span>{{ key }}</span>
                                                <i :class="expandedCategories[key] ? 'fas fa-chevron-up' : 'fas fa-chevron-down'" class="ml-auto"></i>
                                            </h5>
                                            <div v-if="expandedCategories[key]" class="mt-2">
                                                <div v-for="permission in category" :key="permission.id" class="form-group px-4">
                                                    <input
                                                        type="checkbox"
                                                        :id="`perm-${permission.id}`"
                                                        v-model="form.permissions"
                                                        :value="permission.id"
                                                        class="custom-checkbox"
                                                    >
                                                    <label :for="`perm-${permission.id}`">{{ formatPermissionName(permission.name) }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <h3 class="text-3">Selected Roles</h3>
                                        <hr>
                                        <div v-if="selectedPermissions.length">
                                            <div v-for="permission in selectedPermissions" :key="permission.id" class="mb-3">
                                                <h5 class="text-2">{{ formatPermissionName(permission.name) }}</h5>
                                                <small>{{ permission.description }}</small>
                                            </div>
                                        </div>
                                        <div v-else>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12">
                                <button @click.prevent="create"
                                        :class="['btn btn-primary btn-block mt-2' ,  form.loading ? 'btn-loading' : '']"
                                        type="submit">Create User
                                </button>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
import Form from "../../../core/forms/form";

export default {
    name: "Index",
    data() {
        return {
            allPermissions: [],
            expandedCategories: {},
            permissionCategories: {},
            selectedPermissions: [],
            form: new Form({
                first_name: '',
                last_name: '',
                phone: '',
                email: '',
                password: '',
                password_confirmation: '',
                permissions: [],
            })
        };
    },

    mounted() {
        this.init();
    },
    watch: {
        'form.permissions': {
            handler(newVal) {
                this.selectedPermissions = this.allPermissions.filter(p => newVal.includes(p.id));
            },
            immediate: true,
            deep: true
        }
    },


    methods: {
        init() {
            window.axios.get(`/business/permissions`).then((response) => {
                this.allPermissions = response.data.body.list;
                this.processPermissions();
            });
        },

        processPermissions() {
            const grouped = {};
            this.allPermissions.forEach(permission => {
                if (!grouped[permission.category]) grouped[permission.category] = [];
                grouped[permission.category].push(permission);
            });
            this.permissionCategories = grouped;
        },

        toggleCategory(category) {
            this.$set(this.expandedCategories, category, !this.expandedCategories[category]);
        },

        create() {
            this.form.submit('/business/users/create').then(() => {
                this.$router.push("/business/users");
            });
        },

        formatPermissionName(name) {
            return name.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
        }
    }
}
</script>

<style scoped>
.text-2 {
    font-size: 14px;
    font-weight: bold;
}
.text-3 {
    font-size: 16px;
    font-weight: 600;
}
</style>

